import ModalWrapper from '@components/wrapper/Modal/ModalWrapper';
import React from 'react';
import styled from 'styled-components';
import ResetPassword from './ResetPassword';

type Props = {
  close?: () => void;
};
function ResetPasswordModal({ close }: Props) {
  return (
    <ModalWrapper outsideClick={close} contentStyle={{ minWidth: 420 }}>
      <ResetPassword close={close} />
    </ModalWrapper>
  );
}

export default ResetPasswordModal;
